export const ConvertToTransactionNumberList = (transactionNumberListRaw: any) => {
  const transactionNumberList = [];
  if (transactionNumberListRaw && transactionNumberListRaw.length > 0) {
    for (const transactionNumberRaw of transactionNumberListRaw) {
      transactionNumberList.push({
        id: transactionNumberRaw.id,
        number: transactionNumberRaw.number,
        financeType: transactionNumberRaw.financeType,
        transactionItemType: transactionNumberRaw.transactionItemType,
      });
    }
  }
  return transactionNumberList;
};
